export const generateUniqueRowId = (added) => {
  let id = crypto.randomUUID();
  if (added) {
    id = "added_" + id;
  }
  return id;
};
